import { roleModel } from '@ucr/role-model';
import { useCallback } from 'react';

import { TPermissionKey, TRoleKey } from '../../types';

const emptyActions = {
  getCurrentRole: () => undefined,
  getCurrentRolePermissions: () => undefined,
  hasPermission: (_: TPermissionKey) => false,
};

/** Хук для управления состоянием разрешений ролей */
export const usePermissions = (currentRoleKey?: TRoleKey) => {
  const getCurrentRole = useCallback(() => {
    return roleModel.roles.find((role) => role.key === currentRoleKey);
  }, [currentRoleKey]);

  const getCurrentRolePermissions = useCallback(() => {
    return getCurrentRole()?.permissions;
  }, [getCurrentRole]);

  const hasPermission = useCallback(
    (permissionKey: TPermissionKey) => {
      return !!getCurrentRolePermissions()?.find(
        (p) => p.key === permissionKey,
      );
    },
    [getCurrentRolePermissions],
  );

  if (!currentRoleKey) return emptyActions;

  return {
    getCurrentRole,
    getCurrentRolePermissions,
    hasPermission,
  };
};
